import { Link } from 'react-router-dom';
import { PlayCircle } from 'lucide-react';

import { isExternalHref, isVideoTutorialHref, toInAppHelpPath, toInAppPath } from '@/app/helpArticle/_helpers';

import { Button } from '@/app/ui/button';

const linkClassName = 'text-primary font-medium break-words underline underline-offset-4 hover:no-underline';

// A video tutorial is a button. A link to another help article stays in the app,
// as does a path in it (the assistant may answer with one); anything else on the
// web opens in a new tab as a plain link.
const ViewHelpMarkdownLink = ({ href, children }) => {
  if (isVideoTutorialHref(href)) {
    return (
      <Button variant="outline" asChild>
        <a href={href} target="_blank" rel="noopener noreferrer" data-testid="help-article-video-link">
          <PlayCircle />
          Watch the video tutorial
        </a>
      </Button>
    );
  }
  const inAppPath = toInAppHelpPath(href) ?? toInAppPath(href);
  if (inAppPath) {
    return (
      <Link to={inAppPath} className={linkClassName}>
        {children}
      </Link>
    );
  }
  if (isExternalHref(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={linkClassName}>
        {children}
      </a>
    );
  }
  return (
    <a href={href} className={linkClassName}>
      {children}
    </a>
  );
};

export default ViewHelpMarkdownLink;
